import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackNavigation, addBreadcrumb } from "src/helpers/context/sentry";
import { trackMixpanelPageView } from "src/helpers/context/mixpanel";

const SentryRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackNavigation(location);
    trackMixpanelPageView(location);
    addBreadcrumb({
      category: "ui.lifecycle",
      level: "info",
      message: "route.changed",
      data: {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
      },
    });
  }, [location]);

  return null;
};

export default SentryRouteTracker;
